import type { KaggleTier } from "./kaggleTiers";

export type ActiveCompetitionParticipant = {
  kaggle_id: string;
  grade: string;
  kaggle_tier: KaggleTier | null;
  aiyss_rank: number;
  overall_rank: number;
};

export type ActiveCompetition = {
  competition_key: string;
  id: number | null;
  slug: string;
  title: string;
  url: string | null;
  ends_at: string;
  participant_count: number | null;
  registered_participant_count: number;
  fetched_at: string;
  participants: ActiveCompetitionParticipant[];
};

export const mockActiveCompetitions: ActiveCompetition[] = [
  {
    competition_key: "development-active-competition",
    id: 100001,
    slug: "development-active-competition",
    title: "Development Active Competition",
    url: "https://www.kaggle.com/competitions/development-active-competition",
    ends_at: "2026-09-30 08:59:00",
    participant_count: 3120,
    registered_participant_count: 3,
    fetched_at: "2026-08-24 12:00:00",
    participants: [
      {
        kaggle_id: "sample_challenger",
        grade: "高2",
        kaggle_tier: "grandmaster",
        aiyss_rank: 1,
        overall_rank: 45,
      },
      {
        kaggle_id: "university_ai_demo",
        grade: "大3",
        kaggle_tier: "expert",
        aiyss_rank: 2,
        overall_rank: 183,
      },
      {
        kaggle_id: "data_youth_01",
        grade: "高1",
        kaggle_tier: "master",
        aiyss_rank: 3,
        overall_rank: 450,
      },
    ],
  },
];

export const mockCompletedCompetitions: ActiveCompetition[] = [
  {
    competition_key: "development-completed-competition",
    id: 100002,
    slug: "development-completed-competition",
    title: "Development Completed Competition",
    url: "https://www.kaggle.com/competitions/development-completed-competition",
    ends_at: "2026-07-31 08:59:00",
    participant_count: 2840,
    registered_participant_count: 3,
    fetched_at: "2026-08-24 12:00:00",
    participants: [
      {
        kaggle_id: "data_youth_01",
        grade: "高1",
        kaggle_tier: "master",
        aiyss_rank: 1,
        overall_rank: 72,
      },
      {
        kaggle_id: "sample_challenger",
        grade: "高2",
        kaggle_tier: "grandmaster",
        aiyss_rank: 2,
        overall_rank: 148,
      },
      {
        kaggle_id: "university_ai_demo",
        grade: "大3",
        kaggle_tier: "expert",
        aiyss_rank: 3,
        overall_rank: 391,
      },
    ],
  },
];
